'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
  );
};
ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
ImageRemoveRedEye.muiName = 'SvgIcon';

exports.default = ImageRemoveRedEye;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/remove-red-eye.js
 ** module id = 448
 ** module chunks = 0
 **/